  <ng-container *ngIf="order$ | async as order">
    <ng-container *ngIf="status$ | async as status">
      <div class="header">
        <div class="navigation-buttons">
          <button matFab id="order-processing-back" [disabled]="current === 0" (click)="getPreviousLine()"><mat-icon>arrow_back</mat-icon></button>
          <button matFab id="order-processing-forward" (click)="getNextLine()"><mat-icon>arrow_forward</mat-icon></button>
        </div>
        
        <div class="product-buttons">
          <button matButton="outlined" id="order-processing-search-description" (click)="searchByDescription()">Search by Description</button>
          <button matButton="outlined" id="order-processing-edit-product" (click)="editProduct()">Edit Product</button>
          <button matButton="outlined" id="order-processing-new-product" (click)="newProduct()">New Product</button>
          <button matButton="outlined" id="order-processing-direct-supply" [disabled]="line?.LineID && (status.Confirmed || status.Received || status.Cancelled)" (click)="directSupply()">Direct Supply</button>
        </div>

        <div class="misc-buttons">
          <button *ngIf="line?.LineID" matButton="outlined" id="order-processing-view-notes" (click)="viewNotes('orderlines', line?.LineID)">View Notes</button>
          <button matButton="outlined" id="order-processing-close" (click)="closeDialog()">Close</button>
        </div>
      </div>

      <div class="client-details">
        <div class="meta-item">
          <span class="meta-label">Account:</span>
          <span class="meta-value">{{order.Client.AccountNo}} - {{order.Client.Name}}</span>
        </div>
        <div class="meta-item">
          <span class="meta-label">Reference:</span>
          <span class="meta-value">{{order.SOReference}}</span>
        </div>
      </div>

      <div class="product-details">
        <mat-form-field appearance="outline" floatLabel="always" [ngClass]="{readonly: status.Confirmed}">
          <mat-label>Order Line</mat-label>
          <input matInput type="number" [min]="1" [step]="1" [(ngModel)]="line.POLine" [readonly]="status.Confirmed" />
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="code">
          <mat-label>Product Code</mat-label>
          <input matInput type="text" [(ngModel)]="line.Reference" (focusout)="startSearch()" />
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="description">
          <mat-label>
            Description
            <ng-container *ngIf="line?.SupplierText">
              of product from
              <ng-container *ngIf="line?.Url; else supplierText">
                <a [href]="line?.Url" target="_blank">{{line.SupplierText}}</a>
              </ng-container>
              <ng-template #supplierText>{{line?.SupplierText}}</ng-template>
            </ng-container>
          </mat-label>
          <input matInput type="text" [(ngModel)]="line.Description" />
          <mat-error *ngIf="!line?.Description">
            Please enter a description for the product
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="quantity" [ngClass]="{readonly: status.Ordered}">
          <mat-label>Quantity</mat-label>
          <input matInput type="number" [min]="1" [step]="1" [(ngModel)]="line.Quantity" [readonly]="status.Ordered" />
          <mat-error *ngIf="!line?.Quantity">
            Please enter a valid quantity
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" class="cost" [ngClass]="{readonly: initialUnitPrice > 0}">
          <mat-label>Estimated Cost</mat-label>
          <input matInput type="number" [min]="0" [step]="0.01" [(ngModel)]="line.EstimatedUnitPrice" [readonly]="initialUnitPrice > 0" />
        </mat-form-field>
      </div>

      <div class="product-list">
        <ng-container *ngIf="dataSource$ | async as dataSource">
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="Notes">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" (dblclick)="viewNotes('products', row.EMSProductID)">{{row.NoteCount > 0 ? 'N' : ''}}</td>
              </ng-container>
              <ng-container matColumnDef="Supplier">
                <th mat-header-cell *matHeaderCellDef>Supplier</th>
                <td mat-cell *matCellDef="let row">{{row.Supplier}}</td>
              </ng-container>
              <ng-container matColumnDef="Code">
                <th mat-header-cell *matHeaderCellDef>Code</th>
                <td mat-cell *matCellDef="let row">{{row.Code}}</td>
              </ng-container>
              <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let row">{{row.Description}}</td>
              </ng-container>
              <ng-container matColumnDef="Catalogue">
                <th mat-header-cell *matHeaderCellDef>Catalogue</th>
                <td mat-cell *matCellDef="let row">{{row.Catalogue}}</td>
              </ng-container>
              <ng-container matColumnDef="Unit">
                <th mat-header-cell *matHeaderCellDef>Unit</th>
                <td mat-cell *matCellDef="let row">{{row.PackSize}}</td>
              </ng-container>
              <ng-container matColumnDef="Cost">
                <th mat-header-cell *matHeaderCellDef>Cost</th>
                <td mat-cell *matCellDef="let row">{{row.UnitCost * (1 - row.Discount) | currency: row.CurrencyCode}}</td>
              </ng-container>
              <ng-container matColumnDef="Price">
                <th mat-header-cell *matHeaderCellDef>Price</th>
                <td mat-cell *matCellDef="let row">{{row.UnitValue | currency: row.CurrencyCode}}</td>
              </ng-container>
              <ng-container matColumnDef="Commodity">
                <th mat-header-cell *matHeaderCellDef>Commodity</th>
                <td mat-cell *matCellDef="let row">{{row.CommodityType}}</td>
              </ng-container>
              <ng-container matColumnDef="Stock">
                <th mat-header-cell *matHeaderCellDef>Stock</th>
                <td mat-cell *matCellDef="let row">{{row.Stock}}</td>
              </ng-container>
              <ng-container matColumnDef="DataSource">
                <th mat-header-cell *matHeaderCellDef>DataSource</th>
                <td mat-cell *matCellDef="let row">{{row.DataSource}}</td>
              </ng-container>
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">{{row.Status}}</td>
              </ng-container>
              <ng-container matColumnDef="LastImported">
                <th mat-header-cell *matHeaderCellDef>Last Imported</th>
                <td mat-cell *matCellDef="let row">{{row.LastImported | date: 'd MMM yyyy'}}</td>
              </ng-container>
              <ng-container matColumnDef="PricingExpiry">
                <th mat-header-cell *matHeaderCellDef>Pricing Expiry</th>
                <td mat-cell *matCellDef="let row">{{row.PricingExpiry | date: 'd MMM yyyy'}}</td>
              </ng-container>
              <ng-container matColumnDef="Distributor">
                <th mat-header-cell *matHeaderCellDef>Distributor</th>
                <td mat-cell *matCellDef="let row">{{row.Distributor}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr
                mat-row *matRowDef="let row; columns: displayedColumns;"
                (click)="selectProduct(row)"
                [ngClass]="{
                  selected: selectedProduct && (selectedProduct.ProductID ? selectedProduct.ProductID == row.ProductID : selectedProduct.EMSProductID == row.EMSProductID),
                  lineProduct: row.EMSProductID === initLine?.Product
                }"
              ></tr>
            </table>
        </ng-container>
      </div>

      <div class="footer">
        <div class="pricing-panel">
          <div class="sales-overview">
            <div class="sale-price">
              <div class="price">
                <span>Sale: ( </span>
                <ng-container>
                  <input matInput type="number" [min]="0" [max]="100" [step]="0.01" [(ngModel)]="line.UnitPrice" />
                  <span> {{order.Currency.Code}}</span>
                  <span *ngIf="lineSurcharge$ | async as lineSurcharge"> + {{lineSurcharge | percent}}</span>
                </ng-container>
              </div>
              <div class="sale-price-buttons">
                <button matButton="outlined" class="estimated" (click)="minCost()">Estimated</button>
                <button matButton="outlined" class="max" (click)="maxCost()">Max</button>
                <button matButton="outlined" class="normalise" (click)="normaliseCost()">Normalise</button>
              </div>
            </div>
            <div class="sales-discount">
              <div class="discount">
                <span> + </span>
                <input matInput type="number" [min]="0" [max]="100" [step]="0.01" [(ngModel)]="line.CustomerDiscount" />
                <span> % )</span>
              </div>
              <div class="discount-buttons">
                <button matButton="outlined" class="zero" (click)="disc0()">0%</button>
                <button matButton="outlined" class="seven-five" (click)="disc7_5()">7.5%</button>
                <button matButton="outlined" class="fifteen" (click)="disc15()">15%</button>
                <button matButton="outlined" class="current" (click)="discCurrent()">Current: {{currentDiscount}}%</button>
                <button matButton="outlined" class="max" (click)="discMax()">Max</button>
              </div>
            </div>
          </div>
          <div class="price-overview">
            <ng-container *ngIf="selectedProduct$ | async as selectedProduct">
              <ng-container *ngIf="selectedProduct">
                <ng-container *ngIf="financeStatus$ | async as financeStatus">
                  <div>
                    = {{(line?.UnitPrice ?? 0) * (1 - (line?.CustomerDiscount ?? 0) / 100) | number: '1.2-2'}} {{order.Currency.Code}} x {{line?.Quantity ?? 1}}
                    = {{roundNumber(((line?.UnitPrice ?? 0) * (1 - (line?.CustomerDiscount ?? 0) / 100)), 2) * (line?.Quantity ?? 1) | number: '1.2-2'}} {{order.Currency.Code}}
                  </div>
                  <div *ngIf="line?.LineID && !status.Cancelled && financeStatus.Priced; else elseCost">
                    Cost: {{(line?.LineCost ?? 0) / selectedProduct.Exchange / (line?.ProductQuantity ?? 1) | number: '1.2-2'}} {{selectedProduct.CurrencyCode}} x {{line?.ProductQuantity}}
                      = {{(line?.LineCost ?? 0) / selectedProduct.Exchange | number: '1.2-2'}} {{selectedProduct.CurrencyCode}}
                      = {{(line?.LineCost ?? 0) / order.Currency.ExchangeRate | number: '1.2-2'}} {{order.Currency.Code}}
                  </div>
                  <ng-template #elseCost>
                    <div>
                      Cost: ({{selectedProduct.UnitCost | number: '1.2-2'}} {{selectedProduct.CurrencyCode}} - {{selectedProduct.Discount | percent}})
                        = {{selectedProduct.UnitCost * (1 - selectedProduct.Discount) | number: '1.2-2'}} {{selectedProduct.CurrencyCode}} x {{line?.ProductQuantity}}
                        = {{selectedProduct.UnitCost * (1 - selectedProduct.Discount) * (line?.ProductQuantity ?? 1) | number: '1.2-2'}} {{selectedProduct.CurrencyCode}}
                        = {{selectedProduct.UnitCost * (1 - selectedProduct.Discount) * (line?.ProductQuantity ?? 1) * (selectedProduct.CurrencyCode == order.Currency.Code ? 1 : selectedProduct.Exchange / order.Currency.ExchangeRate) | number: '1.2-2'}} {{order.Currency.Code}}
                    </div>
                  </ng-template>
                  <div>
                    Handling Charge = {{line?.HandlingCharge ?? 0 | number: '1.2-2'}} {{order.Currency.Code}}
                  </div>
                  <div>
                    Profit = {{
                      (roundNumber((line?.UnitPrice ?? 0) * (1 - (line?.CustomerDiscount ?? 0) / 100), 2) * (line?.Quantity ?? 0)) - (
                        line?.LineID && !status.Cancelled && financeStatus.Priced ? (line?.LineCost ?? 0) / order.Currency.ExchangeRate :
                        selectedProduct.UnitCost * (1 - selectedProduct.Discount) * (line?.ProductQuantity ?? 1) * (selectedProduct.CurrencyCode == order.Currency.Code ? 1 : selectedProduct.Exchange / order.Currency.ExchangeRate)
                      ) - (line?.HandlingCharge ?? 0) | number: '1.2-2'
                    }} {{order.Currency.Code}}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="pricing-buttons">
            <div>
              <button matButton="outlined" (click)="priceCat()">Cat Price</button>
              <button matButton="outlined" (click)="priceDesiredProfit()">Desired Profit</button>
            </div>
            <div>
              <button matButton="outlined" (click)="priceCatPlus10()">Cat + 10%</button>
              <button matButton="outlined" (click)="price15PercentProfit()">15% Profit</button>
            </div>
            <div>
              <button matButton="outlined" (click)="priceProductSalePrice()">Product Sale Price</button>
              <button matButton="outlined" (click)="priceMinProfit()">Min Profit</button>
            </div>
          </div>
        </div>
        <div class="actions-panel">
          <div>
            <button matButton="outlined" [disabled]="selectedProduct?.PricingExpiry !== null && pricingValid(selectedProduct?.PricingExpiry)" (click)="pricingConfirmedOk()">Pricing Confirmed OK</button>
            <button matButton="outlined" (click)="notAvailable()">Not Available</button>
          </div>
          <div>
            <button matButton="outlined" [disabled]="line?.LineID && status.Confirmed && line?.Status !== 46 && line?.Status !== 47" (click)="toQueryWithClient()">To Query with Client</button>
            <button matButton="outlined" [disabled]="line?.LineID && status.Confirmed" (click)="quoteRequired()">Quote Required</button>
          </div>
          <div>
            <button matButton="outlined" [disabled]="line?.LineID" (click)="addToWebOrder()">Add To Web Order</button>
            <button matButton="filled" (click)="accept()">{{line?.LineID ? 'Accept' : 'Add to PF&Q'}}</button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>